export default __webpack_public_path__ + "static/media/logoTextBlackC.df138e98.svg";